<template>
  <div class="flex">
    <div v-if="has_all_subject">General</div>
    <div v-else-if="params.value.length < 2">
      <span
        class="all_tags_holder_block"
        style="word-break: break-word; white-space: normal"
      >
        <span
          class="tag_span"
          :style="{
            padding: '3px 0px',
          }"
        >
          <span
            style="
              line-height: 16px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: inline-block;
              position: relative;
              top: 2px;
              margin-right: 5px;
            "
          >
            {{ params.data.subject.length>0?params.data.subject[0].subject_name:'' }}
          </span>
        </span>
      </span>
    </div>
    <div v-else-if="params.value.length > 1">
      <span
        class="all_tags_holder_block"
        style="word-break: break-word; white-space: normal"
      >
        <span
          class="tag_span"
          :style="{
            padding: '3px 0px',
          }"
        >
          <span
            style="
              line-height: 16px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: inline-block;
              position: relative;
              top: 2px;
              margin-right: 5px;
            "
          >
            {{ params.data.subject.length>0?params.data.subject[0].subject_name:'' }} ..
          </span>
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TagShow',
  mounted () {
    if (this.params.data.has_all_subject !== undefined) {
      this.has_all_subject = this.params.data.has_all_subject
    } else {
      this.has_all_subject = this.params.data.assignment_builder.has_all_subject
    }
  },
  data () {
    return {
      has_all_subject:false
    }
  }
}
</script>

